export const environment = {
  production: false,
  clientId: '1_47ma9q2hh3uoo4gg4wkkos08o0800w0s4o0ssockcsggsks4c8',
  clientSecret: '3zaif1speb8kccok000scg08480os88g4c4owswc0w0o0c4g4s',
  loginUrl: 'https://openfiber-backend-api-73-review34.mashfrogcloud.com/oauth/v2/token',
  apiUrl: 'https://openfiber-backend-api-73-review34.mashfrogcloud.com',
  BASE_KML_URL: 'https://openfiber-backend-api-73-review34.mashfrogcloud.com/api2/marketing/data/kml/',
  redirectSSOUrl: 'https://openfiber-landing-193-review69.mashfrogcloud.com/',
  redirectSSOErr: 'https://openfiber-landing-193-review69.mashfrogcloud.com/marketing/home',
  requestsLinkUrl: 'https://openfiber-it--newdev2.sandbox.my.site.com',
  funnelHome: '/OFPortaleOperatori',
  funnelRequests: '/OFVenditaServizi/s/richieste-bea',
  path: 'serviziobea',
  serviceSlug: 'bea',
  local: false,
  controls: {
    massive_import_two_steps: false,
    agf: true,
    agf_pop: true,
    unique_environment: true
  }
};
